import Header from "./Header";
import Footer from "./Footer";
import EmailVerificationBanner from "../EmailVerificationBanner";
import AnnouncementsBanner from "../AnnouncementsBanner";
import PageTracker from "../PageTracker";
import CookieConsent from "../CookieConsent";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-background demka-grain">
      <PageTracker />
      <Header />
      <AnnouncementsBanner />
      <EmailVerificationBanner />
      <main className="flex-1">{children}</main>
      <Footer />
      <CookieConsent />
    </div>
  );
}
